import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { MdClose, MdCheck } from "react-icons/md";

import FieldError from "../../../shared/FieldError";

const HbA1c = ({ data, handleField }) => {
  const HbA1cSchema = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .matches(/^\d*\.{1}\d*$/, "value must be a floating point (decimal)"),
  });

  return (
    <div>
      <Formik
        initialValues={{
          data: data.value,
        }}
        validationSchema={HbA1cSchema}
        validateOnChange={true}
        onSubmit={async (values) => {
          const request = await handleField({
            id: data.id,
            cpr_id: data.cprId,
            value: values.data,
            quality_measurement_type_id: data.quality_measurement_type_id,
          });
          console.log(request);
        }}
      >
        {({ values, errors, setFieldValue, initialValues }) => {
          return (
            <Form>
              <label>
                HbA1c <span id="from">hemoglobin A1c (HbA1c) test</span>
              </label>
              <input
                className="default"
                placeholder="e.g. 5.23"
                value={values.data}
                onChange={(e) => {
                  setFieldValue("data", e.target.value);
                }}
              />
              {handleField && initialValues.data !== values.data && !errors.data && (
                <div className="check-cancel-buttons flex">
                  <button className="check small" type="submit">
                    <MdCheck className="check-icon" />
                  </button>
                  <button
                    className="cancel small"
                    onClick={() => {
                      initialValues.data
                        ? setFieldValue("data", initialValues.data)
                        : setFieldValue("data", "");
                    }}
                  >
                    <MdClose className="cancel-icon" />
                  </button>
                </div>
              )}
              {errors.data ? <FieldError error={errors.data} /> : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default HbA1c;
